import { render, staticRenderFns } from "./SysDepartRoleModal.vue?vue&type=template&id=814d02b0&scoped=true"
import script from "./SysDepartRoleModal.vue?vue&type=script&lang=js"
export * from "./SysDepartRoleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814d02b0",
  null
  
)

export default component.exports